import React from 'react';

import blankFormState from './blank-form-state';

export default React.createContext({ ...blankFormState() });
